import React, { Component, FormEvent, HTMLProps } from 'react';
import Icon from '../../icons/Icon';
import { ComponentErrorStatus, ComponentRule } from './rule/ComponentRule';

class FormicaInput extends Component<Props> {
  render() {
    const { className, inputSize = 'sm', inputType = 'default', type, placeholder, icon = 'edit', ...rest } = this.props;
    return (
      <div style={{ boxShadow: inputType != 'ghost' ? '1px 1px 2px 0px #0000000D' : 'none' }} className={`flex ${this.getSize()} w-full relative group`}>
        <input className={`${this.getInputClasses(inputType)} ${className}`} placeholder={placeholder} type={type} {...rest} />
        <span className={'absolute right-2 top-0 h-full formica-input flex items-center '}>
          {type != 'number' && <Icon className={'group-hover:text-f-purple text-f-black-2'} icon={icon} size={16} />}
        </span>
      </div>
    );
  }

  private increaseValue = (e: FormEvent<HTMLInputElement>) => () => {
    const { value, onChange } = this.props;
    if (typeof value == 'number' || !isNaN(Number(value))) {
      e.currentTarget.value = String(Number(value) + 1);
      onChange && onChange(e);
    }
  };

  private decreaseValue = () => (e: FormEvent<HTMLInputElement>) => {
    const { value, onChange } = this.props;
    if (typeof value == 'number' || !isNaN(Number(value))) {
      e.currentTarget.value = String(Number(value) + 1);
      onChange && onChange(e);
    }
  };

  private getSize = () => {
    const { inputSize = 'md' } = this.props;
    switch (inputSize) {
      case 'sm':
        return 'h-[32px] min-h-[32px]';
      case 'md':
        return 'h-[34px] min-h-[34px]';
      case 'lg':
        return 'h-[40px] min-h-[40px]';
      default:
        return 'h-[34px] min-h-[34px]';
    }
  };

  private getInputClasses = (inputType: InputType) => {
    switch (inputType) {
      case 'ghost':
        return 'w-full rounded-[4px] disabled:opacity-50 focus:outline-none text-sm focus:formica-shadow outline-none! text-f-black-2 bg-transparent hover:bg-white hover:border-[1px] hover:border-f-purple border-[1px] border-transparent disabled:cursor-not-allowed px-2 py-2';
      default:
        return 'w-full rounded-[4px] disabled:opacity-50 focus:outline-none text-sm focus:formica-shadow outline-none! indent-3 text-f-black-2 border-[1px] border-f-black-5 bg-white focus:border-f-purple hover:border-f-purple disabled:cursor-not-allowed';
    }
  };
}

interface Props extends HTMLProps<HTMLInputElement> {
  inputSize?: 'sm' | 'md' | 'lg';
  inputType?: InputType;
  rules?: ComponentRule[];
  error?: ComponentErrorStatus;
  placeholder?: string;
  icon?: string;
}

export type InputType = 'default' | 'ghost';

export default FormicaInput;
